var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fixed",staticStyle:{"padding-top":"100px"}},[_c('header',[_c('h1',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('common.partnerAdapterErrorHeader'))+" ")])]),_c('div',{staticClass:"text-center"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorText)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }